import { ChangeDetectorRef, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { Subscription } from 'rxjs';

import { LeftSidebarListItem } from '../../../../Common/Layout/models/left-sidebar-list-item.model';
import { TabComponent } from '../../../../Common/Layout/components/Tab/tab.component';
import { ActionKeys } from '../../../../Common/Forms/enums/keys.enum';
import { ScrollPanelComponent } from '../../../../Common/Basic/components/ScrollPanel/scroll-panel.component';

import { userPermissionsEnum } from '../../../../Core/Users/enums/user-permissions.enum';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';

import { UserPreferencesService } from '../../../UserPreferences/services/user-preferences.service';

enum AccountPreferencesTabIds {
    MONITOR_SETTINGS = 'accountPreferences.monitorSettingTab',
    ATTRIBUTIONS = 'accountPreferences.attributions',
}

type AccountPrefsListItemsKey = keyof Pick<AccountPreferencesComponent, 'monitoringListItems'>;

@Component({
    selector: 'agpr-account-preferences',
    templateUrl: './account-preferences.component.html',
    styleUrls: ['./account-preferences.component.scss'],
    standalone: false
})
// TODO: add scroll to position function
export class AccountPreferencesComponent implements OnDestroy{
    // for left side bar
    monitoringListItems: LeftSidebarListItem[] = [];

    hasMonitoring: boolean = false;
    hasTargeting: boolean = false;
    subscriptions: Subscription[] = [];
    loading: boolean = false;

    selectedTabIndex: number = 0;
    selectedTabId: string;
    tabIds = AccountPreferencesTabIds;

    @ViewChild('scrollPanel') scrollPanel: ScrollPanelComponent;

    constructor(
        private currentUserStateService: CurrentUserStateService,
        private userPreferencesService: UserPreferencesService,
        private titleService: Title,
        private localizationService: LocalizationService,
        private cd: ChangeDetectorRef,
    ) {
        this.subscriptions.push(
            this.currentUserStateService.getPermissions().subscribe(permissions => {
                if (permissions) {
                    this.hasTargeting = permissions.includes(userPermissionsEnum.advancedTargeting);
                    this.hasMonitoring = permissions.includes(userPermissionsEnum.advancedMonitoring);

                    requestAnimationFrame(() => {
                        // Initially select the first tab by default
                        this.tabIndexChange(0);
                    });
                }
            }),
            this.userPreferencesService.loading$.subscribe(x => {
                this.loading = x;
            })
        );
        this.titleService.setTitle(
            this.localizationService.transform(
                'Account.accountPrefs.browserTitle'
            )
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    tabIndexChange(index: number): void {
        this.selectedTabIndex = index;
    }

    tabChange(tab: TabComponent): void {
        this.selectedTabId = tab.id;
    }

    updateSectionListItems(key: AccountPrefsListItemsKey, listItems: LeftSidebarListItem[]) {
        this[key] = listItems;
        this.cd.detectChanges();
    }

    scrollToSection(section: ElementRef, event?: any) {
        if (event instanceof KeyboardEvent && !(event.key === ActionKeys.ENTER || event.key === ActionKeys.SPACE)) {
            return;
        }
        const elRect = section.nativeElement.getBoundingClientRect();
        const spEl = this.scrollPanel.sp.contentViewChild.nativeElement;
        const spRect = spEl.getBoundingClientRect();
        const top = Math.max(elRect.top - spRect.top + spEl.scrollTop);
        this.scrollPanel.scrollTo(top);
    }
}
